/* HH — product page helpers (UI Design 22/10/2026). Presentation only — group-order.js owns prices, cart and
   the minimum rule. 1) Size-range tabs (Unisex / Men · Women · Kids): show one group, keep every cell in the DOM so
   group-order.js still finds it under #gof-size-grid; a count badge on each tab shows pieces entered in hidden groups.
   2) "Size guide" link: open the Size guide block (<details id="size-guide-box">) and scroll to it. */
(function () {
  'use strict';
  function init() {
    var root = document.getElementById('group-order-form');
    if (!root) return;
    var tabs = root.querySelectorAll('[data-gof-tab]');
    var panels = root.querySelectorAll('.gof-size-group');
    function show(key) {
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i].getAttribute('data-gof-tab') === key;
        tabs[i].classList.toggle('is-active', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      for (var j = 0; j < panels.length; j++) {
        panels[j].classList.toggle('is-active', panels[j].getAttribute('data-size-group') === key);
      }
    }
    for (var t = 0; t < tabs.length; t++) {
      tabs[t].addEventListener('click', function () { show(this.getAttribute('data-gof-tab')); });
    }
    function counts() {
      for (var p = 0; p < panels.length; p++) {
        var n = 0, inputs = panels[p].querySelectorAll('input.gof-qty-input');
        for (var k = 0; k < inputs.length; k++) n += parseInt(inputs[k].value, 10) || 0;
        var badge = root.querySelector('[data-gof-count="' + panels[p].getAttribute('data-size-group') + '"]');
        if (badge) { badge.textContent = n; badge.hidden = !n; }
      }
    }
    root.addEventListener('input', counts);
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.gof-qty-btn')) setTimeout(counts, 0);
    });

    var links = document.querySelectorAll('a[href="#size-guide"]');
    for (var l = 0; l < links.length; l++) {
      links[l].addEventListener('click', function (e) {
        var box = document.getElementById('size-guide-box');
        if (!box) return;
        e.preventDefault();
        box.open = true;
        box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
